import {App} from '@src/App'
import {GLOBALS} from '@src/build-env'
import {isProd} from '@src/utils/is-prod'
import {createRoot} from 'react-dom/client'

import './index.css'

const $container = document.querySelector('#root')

if (!$container) {
  alert('Root container not found - Major Issues')
} else {
  createRoot($container).render(<App />)
}

// Load Sentry after first paint so its ~25KB gz stays out of the entry chunk.
if (import.meta.env.MODE !== 'development') {
  const initSentry = () =>
    import('@sentry/react').then((Sentry) => {
      Sentry.init({
        dsn: 'https://c6ee5e5118154fb58ec2ebe62b3efad1@o128985.ingest.sentry.io/6519047',
        environment: isProd ? 'production' : 'sandbox',
        ignoreErrors: ['ResizeObserver'],
        release: GLOBALS.BUILD_DATE,
        replaysOnErrorSampleRate: 1.0,
      })
    })

  if ('requestIdleCallback' in window) requestIdleCallback(initSentry)
  else setTimeout(initSentry, 0)
}
